import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { TileLayer, Marker, useMapEvents, Popup, Circle } from 'react-leaflet';
import { FormikProps, useField } from 'formik';
import axios from 'axios';
import _ from 'lodash';
import { FormikAutocompleteMultiple } from '../../../shared/Formik/FormikAutocompleteMultiple';
import { BannerWrapper } from '../../CreateCampign.styles';
import { StyledField, Label } from '../../CreateCampign.styles';
import { StyledMapContainer, DeleteButton } from './Location.styles';

const MapController = ({ callback }: any) => {
  const map = useMapEvents({
    click: (e: any) => {
      const { lat, lng } = e.latlng;
      callback({ lat, lng })
    }
  })
  return null;
}

export const Location = (props: FormikProps<any>) => {
  const [specialtySearch, setSpecialtySearch] = useState('');
  const [specialtyOptions, setSpecialtyOptions] = useState([]);
  const [field, meta, helpers] = useField('location.coords');
  const [markers, setMarkers] = useState<any>(field.value);
  const [specialtyField, specialtyMeta, specialtyHelpers] = useField('location.specialties');
  const saveMarkers = (newMarkerCoords: any) => {
    const duplicateIndex = markers.findIndex((el: any) => el.lat === newMarkerCoords.lat && el.lng === newMarkerCoords.lng);
    if (duplicateIndex === -1) {
      helpers.setValue([...markers, newMarkerCoords])
      setMarkers([...markers, newMarkerCoords]);
    } else {
      const newMarkers = markers.filter((el: any) => el.lat !== newMarkerCoords.lat && el.lng !== newMarkerCoords.lng);
      helpers.setValue(markers)
      setMarkers([...newMarkers])
    }
  };

  useEffect(() => {
    if(field) {
      setMarkers([...field.value])
    }  
  }, [])

  useEffect(() => {
    axios.get(`/api/v1/physician-profile/specialties/?q=${specialtySearch}`)
      .then(res => setSpecialtyOptions(res.data));
  }, [specialtySearch])

  const setSpecialty = (specialty: any) => {
    specialtyHelpers.setValue([...specialty])
  };
  const deleteMarker = (pin: any) => {
    const newMarkers = markers.filter((el: any) => el.lat !== pin.lat && el.lng !== pin.lng);
    helpers.setValue(newMarkers);
    setMarkers([...newMarkers]);
  }

  let latCenter = 37.5;
  let lngCenter = -94.20;
  let zoom = 1;
  if (markers.length > 1) {
    const minLat = _.minBy(markers, (loc: any) => loc.lat);
    const minLng = _.minBy(markers, (loc: any) => loc.lng);
    const maxLat = _.maxBy(markers, (loc: any) => loc.lat);
    const maxLng = _.maxBy(markers, (loc: any) => loc.lng);
    if (maxLat && maxLng && minLat && minLng) {
      latCenter = (maxLat.lat + minLat.lat) / 2;
      lngCenter = (maxLng.lng + minLng.lng) / 2;
    }
    if (Math.abs(maxLng.lng - minLng.lng) < 60 && Math.abs(maxLat.lat - minLat.lat) < 60) {
      zoom = 3;
    }
    else if (Math.abs(maxLng.lng - minLng.lng) < 130 && Math.abs(maxLat.lat - minLat.lat) < 130) {
      zoom = 2;
    }
    else if (Math.abs(maxLng.lng - minLng.lng) < 250 && Math.abs(maxLat.lat - minLat.lat) < 250) {
      zoom = 1;
      latCenter = 0;
    }
  }
  else {
    if (markers.length === 1) {
      latCenter = markers[0].lat;
      lngCenter = markers[0].lng;
    }
    if (isMobile) {
      zoom = 3;
      latCenter = 35;
      lngCenter = -97;
    }
    else {
      zoom = 4
    }
  }
  return (
    <>
      <Label>Location</Label>
      <StyledMapContainer center={[latCenter, lngCenter]} zoom={zoom} scrollWheelZoom={true} boundsOptions={{padding: [20, 20]}}>
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <MapController callback={saveMarkers} />
        {markers.map((each: any, index: number) => (
          <Marker key={index} position={[each.lat, each.lng]}>
            <Circle 
              center={[each.lat, each.lng]}
              radius={322000}
              fillOpacity={0.5}
              fillColor="#2a71d48f"
            />
            <Popup>
              <DeleteButton type="button" onClick={() => deleteMarker(each)}>Delete marker</DeleteButton>
            </Popup>
          </Marker>
        ))}
        {markers.length > 0 && <p>Selected locations: {markers.length}</p>}
      </StyledMapContainer>
      <BannerWrapper>To choose location add pins on map. In case of not specified locations, advertise will be displayed <b>globally</b>.</BannerWrapper>
      <br />
      <Label>Specialties</Label>
      <StyledField
        name="location.specialties"
        label="Specialties"
        variant="outlined"
        options={specialtyOptions}
        getSelectedValue={setSpecialty}
        inputProps={{
          onInputChange: setSpecialtySearch,
        }}
        component={FormikAutocompleteMultiple}
      />
      {/* <Label>Pick from Suggested Specialties</Label>
      <SpecialtiesWrapper>
      <SpecialtiesWrapper>
        <p>Dentistry</p>
      </SpecialtiesWrapper>
      <SpecialtiesWrapper>
        <p>Dentistry</p>
      </SpecialtiesWrapper>
      <SpecialtiesWrapper>
        <p>Dentistry</p>
      </SpecialtiesWrapper> */}
      <BannerWrapper>
        Advertisements will be displayed on locations related to selected specialties.
      </BannerWrapper>
    </>
  )
};
